module.exports = __webpack_public_path__ + "static/media/cover_white.1b21fbc1.svg";